import Vue from "vue";
import Router from "vue-router";
import { getMsalInstance, login } from "@/plugins/azureAuth";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: to => {
        // Redirect to Rentsure website (rather than showing a 404 page)
        window.location.href="https://rentsure.com.au";
      },
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/workbench",
          name: "workbench",
          component: () => import("@/view/pages/workbench/Workbench.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/workbench-v2",
          name: "workbench-v2",
          component: () => import("@/view/pages/workbench/WorkbenchV2.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/workbench/clients/:clientId",
          name: "workbench-client",
          component: () => import("@/view/pages/workbench/ClientPage.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/workbench/policies/:policyId",
          name: "workbench-policy",
          component: () => import("@/view/pages/workbench/PolicyCardPage.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/workbench/endorsements/:transactionId",
          name: "workbench-endorsement",
          component: () => import("@/view/pages/workbench/EndorsementPage.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/wizard",
          name: "wizard",
          component: () => import("@/view/pages/wizard/Wizard.vue"),
          children: [
            {
              path: "nb-rn",
              name: "nb-rn",
              component: () => import("@/view/pages/wizard/newbusiness-renewal/NewBusinessRenewal.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            },
            {
              path: "proposal-form",
              name: "proposal-form",
              component: () => import("@/view/pages/wizard/motor-proposal-form/MotorProposalForm.vue")
            },
            {
              path: "proposal-form-init",
              name: "proposal-form-init",
              component: () => import("@/view/pages/wizard/motor-proposal-form/MotorProposalFormInit.vue")
            },
            {
              path: "proposal-form-pdf",
              name: "proposal-form-pdf",
              component: () => import("@/view/pages/wizard/motor-proposal-form/MotorProposalFormPdf.vue")
            },
            {
              path: "fleet-upload",
              name: "fleet-upload",
              component: () => import("@/view/pages/wizard/fleet-upload/FleetUploadForm.vue")
            },
            {
              path: "fleet-upload-processing",
              name: "fleet-upload-processing",
              component: () => import("@/view/pages/wizard/fleet-upload/FleetUploadProcessing.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            },
            {
              path: "nsw-sde-form",
              name: "nsw-sde-form",
              component: () => import("@/view/pages/wizard/nsw-stamp-duty-exemption-form/NSWStampDutyExemptionForm.vue")
            },
            {
              path: "contact-form",
              name: "contact-form",
              component: () => import("@/view/pages/wizard/contact-form/ContactForm.vue")
            },
            {
              path: "coc-form",
              name: "coc-form",
              component: () => import("@/view/pages/wizard/coc/CocForm.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            },
            {
              path: "quote-slip-processing",
              name: "quote-slip-processing",
              component: () => import("@/view/pages/wizard/quote-slip/QuoteSlipProcessing.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            },
            {
              path: "policy-details-view",
              name: "policy-details-view",
              component: () => import("@/view/pages/wizard/policy-details-view/PolicyDetailsView.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            },
            {
              path: "prospect-form",
              name: "prospect-form",
              component: () => import("@/view/pages/wizard/prospect-form/ProspectForm.vue"),
              meta: { requiresAuth: true } // Requires Azure AD authentication
            }
          ]
        },
        {
          path: "/billing-processing/:transactionId",
          name: "billing-processing",
          component: () => import("@/view/pages/billing/BillingProcessing.vue"),
          meta: { requiresAuth: true } // Requires Azure AD authentication
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});

// Navigation guard for Azure AD authentication
router.beforeEach(async (to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    // Check for session token in query params (used by internal Puppeteer PDF generation)
    const sessionToken = to.query.sessionToken;
    if (sessionToken) {
      try {
        const baseUrl = process.env.NODE_ENV === 'development'
          ? 'http://localhost:3000/services'
          : `${window.location.origin}/services`;
        // await axios.get(`${baseUrl}/nb/validate-session-token`, {
        //   headers: { Authorization: `Bearer ${sessionToken}` }
        // });
        // Token is valid - store it for subsequent API calls and allow navigation
        window.__sessionToken = sessionToken;
        console.log('Session token validated. Bypassing Azure AD login for internal access.');
        next();
        return;
      } catch (error) {
        console.error('Session token validation failed:', error);
        // Fall through to normal Azure AD auth
      }
    }
    
    const msalInstance = getMsalInstance();
    const accounts = msalInstance.getAllAccounts();
    
    if (accounts.length === 0) {
      // Not authenticated - redirect to Azure AD login
      console.log('Route requires authentication. Redirecting to Azure AD login...');
      await login();
      // Note: login() will redirect, so we don't call next()
      return;
    }
    
    // User is authenticated - allow navigation
    console.log('User authenticated:', accounts[0].username);
    next();
  }
  else {
    // Route doesn't require authentication - allow navigation
    next();
  }
});
export default router;
